import React from 'react';
import {
    required,
    TextInput,
    DateInput,
    SimpleForm,
    Create,
    SelectInput,
    ArrayInput,
    SimpleFormIterator,
    CardActions,
    ListButton, 
    Toolbar, 
    ShowButton,
    SaveButton, 
    BooleanInput,
    FormDataConsumer ,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import Months from '../../controls/Months'
import Years from '../../controls/Years'
import jwt_decode from 'jwt-decode'
import { Redirect } from 'react-router-dom';
import ErrorBoundary from '../../ErrorBoundary';
import RefractrolLotInput from '../../controls/RefractrolLotInput';
import formStyles from './formStyles';

var role = (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).role : ''): '';
var level =  (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).level : ''): '';
var loc= (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).location : ''): '';
var ins_id= null;


export { default as styles } from './formStyles';
 
const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const UserCreateActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} />
    </CardActions>
);


const UserCreateToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);


const InstCreate = ({classes, ...props }) => (
<ErrorBoundary>  
    <Create actions={<UserCreateActions />}   {...props}>
        <SimpleForm toolbar={<UserCreateToolbar />} >
            {(props && props.location && props.location.ins_id && props.location.ins_id != null && props.location.ins_id != '') ? 
            <>
            <table className={classes.clearTableStyle}>
                <tbody>
                    <tr>
                        <td colSpan={4} ><center><h3>REFRACTOMETER</h3></center></td>
                    </tr>
                    <tr>
                        <td>Center Name:</td><td><TextInput source='center'  label='' defaultValue={loc} default/></td>
                        <td>Month/Year:</td>
                        <td><SelectInput source='months' label='' choices={Months} />&nbsp;
                            <SelectInput source='years' label='' choices={Years} />
                        </td>
                    </tr>
                    <tr>
                        <td>Equipment ID:</td><td><TextInput source='ins_id' disabled   label='' defaultValue={(props && props.location)?( (props.location.ins_id)?props.location.ins_id:ins_id):ins_id} /></td>
                        <td>Booth:</td><td><TextInput source='booth'  label='' /></td>
                    </tr>
                </tbody>
            </table>
            <table className={classes.tableStyle} >
                <tbody  > 
                    <tr >
                        <td className={classes.labelStyle}>Daily Control</td>
                        <td className={classes.labelStyle}>Normal Control</td>
                        <td className={classes.labelStyle}>Low Control</td>
                        <td className={classes.labelStyle}>High Contorl</td>
                        <td className={classes.iniLabelStyle}>Initial</td>
                        <td className={classes.labelStyle}>Date</td>
                        <td className={classes.iniLabelStyle}>QA Initial</td>
                        <td className={classes.labelStyle}>QA Date</td>
                    </tr>
                <FormDataConsumer>
                {({
                    formData, // The whole form data
                    scopedFormData, // The data for this item of the ArrayInput
                    getSource, // A function to get the valid source inside an ArrayInput
                    ...rest
                }) =>
                    ( role==='QA' || role==='Admin' || level > 6 )? (
                    <>
                    
                    <tr > 
                            <td className={classes.labelStyle} >Manufacturer</td>
                            <td className={classes.derivedStyle} ><TextInput source="man_nor"    label="" disabled /></td>
                            <td className={classes.derivedStyle} ><TextInput source="man_low"    label="" disabled /></td>
                            <td className={classes.derivedStyle} ><TextInput source="man_high"    label="" disabled /></td>
                            <td className={classes.inputStyle} ><TextInput source="man_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="man_date"    label=""  locales="en-us"   /></td>
                            <td className={classes.inputStyle} ><TextInput source="man_qa_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="man_qa_date"    label="" locales="en-us"  /></td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Lot Number</td>
                            <td className={classes.controlInputStyle} ><RefractrolLotInput level="nor" className={classes.controlInputStyle} /></td>
                            <td className={classes.controlInputStyle} ><RefractrolLotInput level="low" className={classes.controlInputStyle} /></td>
                            <td className={classes.controlInputStyle} ><RefractrolLotInput level="high" className={classes.controlInputStyle} /></td>
                            <td className={classes.inputStyle}><TextInput source="lot_init"    label="" /></td>
                            <td className={classes.inputStyle}><DateInput source="lot_date"    label=""  locales="en-us"   /></td>
                            <td className={classes.inputStyle}><TextInput source="lot_qa_init"    label="" /></td>
                            <td className={classes.inputStyle}><DateInput source="lot_qa_date"    label=""  locales="en-us" /></td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Manufaturer expiration</td>
                            <td className={classes.derivedStyle} ><TextInput source="man_exp_nor"    label="" disabled /></td>
                            <td className={classes.derivedStyle} ><TextInput source="man_exp_low"    label="" disabled /></td>
                            <td className={classes.derivedStyle} ><TextInput source="man_exp_high"    label="" disabled /></td>
                            <td className={classes.inputStyle} ><TextInput source="man_exp_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="man_exp_date"    label=""  locales="en-us" /></td>
                            <td className={classes.inputStyle} ><TextInput source="man_exp_qa_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="man_exp_qa_date"    label="" locales="en-us"  /></td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Range</td>
                            <td className={classes.controlInputStyle} ><TextInput source="rag_nor"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="rag_low"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="rag_high"    label="" /></td>
                            <td className={classes.inputStyle} ><TextInput source="rag_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="rag_date"    label=""  locales="en-us" /></td>
                            <td className={classes.inputStyle} ><TextInput source="rag_qa_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="rag_qa_date"    label="" locales="en-us"  /></td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Date vial opened</td>
                            <td className={classes.controlInputStyle} ><TextInput source="vop_nor"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="vop_low"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="vop_high"    label="" /></td>
                            <td className={classes.inputStyle} ><TextInput source="vop_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="vop_date"    label=""  locales="en-us" /></td>
                            <td className={classes.inputStyle} ><TextInput source="vop_qa_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="vop_qa_date"    label="" locales="en-us"  /></td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Date vial expires</td>
                            <td className={classes.controlInputStyle} ><TextInput source="vex_nor"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="vex_low"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="vex_high"    label="" /></td>
                            <td className={classes.inputStyle} ><TextInput source="vex_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="vex_date"    label=""  locales="en-us"  /></td>
                            <td className={classes.inputStyle} ><TextInput source="vex_qa_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="vex_qa_date"    label="" locales="en-us"  /></td>
                    </tr>
                    </>):(
                    <>
                    <tr > 
                            <td className={classes.labelStyle} >Manufacturer</td>
                            <td className={classes.derivedStyle} ><TextInput source="man_nor"    label="" disabled /></td>
                            <td className={classes.derivedStyle} ><TextInput source="man_low"    label="" disabled /></td>
                            <td className={classes.derivedStyle} ><TextInput source="man_high"    label="" disabled /></td>
                            <td className={classes.inputStyle} ><TextInput source="man_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="man_date"    label=""  locales="en-us"   /></td>
                            <td className={classes.inputStyle} ><TextInput source="man_qa_init"    label="" disabled /></td>
                            <td className={classes.inputStyle} ><DateInput source="man_qa_date"    label="" locales="en-us" disabled /></td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Lot Number</td>
                            <td className={classes.controlInputStyle} ><RefractrolLotInput level="nor" className={classes.controlInputStyle} /></td>
                            <td className={classes.controlInputStyle} ><RefractrolLotInput level="low" className={classes.controlInputStyle} /></td>
                            <td className={classes.controlInputStyle} ><RefractrolLotInput level="high" className={classes.controlInputStyle} /></td>
                            <td className={classes.inputStyle}><TextInput source="lot_init"    label="" /></td>
                            <td className={classes.inputStyle}><DateInput source="lot_date"    label=""  locales="en-us"  /></td>
                            <td className={classes.inputStyle}><TextInput source="lot_qa_init"    label="" disabled /></td>
                            <td className={classes.inputStyle}><DateInput source="lot_qa_date"    label=""  locales="en-us" disabled /></td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Manufaturer expiration</td>
                            <td className={classes.derivedStyle} ><TextInput source="man_exp_nor"    label="" disabled /></td>
                            <td className={classes.derivedStyle} ><TextInput source="man_exp_low"    label="" disabled /></td>
                            <td className={classes.derivedStyle} ><TextInput source="man_exp_high"    label="" disabled /></td>
                            <td className={classes.inputStyle} ><TextInput source="man_exp_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="man_exp_date"    label=""  locales="en-us" /></td>
                            <td className={classes.inputStyle} ><TextInput source="man_exp_qa_init"    label="" disabled /></td>
                            <td className={classes.inputStyle} ><DateInput source="man_exp_qa_date"    label="" locales="en-us" disabled /></td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Range</td>
                            <td className={classes.controlInputStyle} ><TextInput source="rag_nor"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="rag_low"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="rag_high"    label="" /></td>
                            <td className={classes.inputStyle} ><TextInput source="rag_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="rag_date"    label=""  locales="en-us" /></td>
                            <td className={classes.inputStyle} ><TextInput source="rag_qa_init"    label="" disabled /></td>
                            <td className={classes.inputStyle} ><DateInput source="rag_qa_date"    label="" locales="en-us" disabled /></td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Date vial opened</td>
                            <td className={classes.controlInputStyle} ><TextInput source="vop_nor"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="vop_low"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="vop_high"    label="" /></td>
                            <td className={classes.inputStyle} ><TextInput source="vop_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="vop_date"    label=""  locales="en-us" /></td>
                            <td className={classes.inputStyle} ><TextInput source="vop_qa_init"    label=""  disabled /></td>
                            <td className={classes.inputStyle} ><DateInput source="vop_qa_date"    label="" locales="en-us" disabled /></td>
                    </tr>
                    <tr > 
                            <td className={classes.labelStyle} >Date vial expires</td>
                            <td className={classes.controlInputStyle} ><TextInput source="vex_nor"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="vex_low"    label="" /></td>
                            <td className={classes.controlInputStyle} ><TextInput source="vex_high"    label="" /></td>
                            <td className={classes.inputStyle} ><TextInput source="vex_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="vex_date"    label=""  locales="en-us" disabled  /></td>
                            <td className={classes.inputStyle} ><TextInput source="vex_qa_init"    label="" /></td>
                            <td className={classes.inputStyle} ><DateInput source="vex_qa_date"    label="" locales="en-us" disabled /></td>
                    </tr>
                    </>)
                    }
                    </FormDataConsumer>
                    <tr>
                        <td colSpan={8}>
                        <table  className={classes.tableStyle} >
                            <tr>
                                <td>
                                <ArrayInput source="details" label='Daily Tasks:'>
                                    <SimpleFormIterator  disableReordering >
                                        <DateInput formClassName={classes.inlineBlock} source="dt" label='Date' /> 
                                        <TextInput formClassName={classes.inlineBlock} source="temp" label='Room Temperature 18-29° C'/>
                                        <TextInput formClassName={classes.inlineBlock} source="h2o" label='Distilled H2O ±0.1, 0.0'/>
                                        <TextInput formClassName={classes.inlineBlock} source="normal" label='Normal'/>
                                        <TextInput formClassName={classes.inlineBlock} source="low" label='Low'/>
                                        <TextInput formClassName={classes.inlineBlock} source="high" label='High'/>
                                        <TextInput formClassName={classes.inlineBlock} source="Comments" label='comments'/>
                                        <TextInput formClassName={classes.inlineBlock} source="t_init" label='Tech Initial'/>
                                        <DateInput formClassName={classes.inlineBlock} source="t_date" label='Tech Date' locales="en-us" />
                                        <FormDataConsumer>
                                                {({
                                                    formData, // The whole form data
                                                    scopedFormData, // The data for this item of the ArrayInput
                                                    getSource, // A function to get the valid source inside an ArrayInput
                                                    ...rest
                                                }) =>
                                                    ( role==='QA' || role==='Admin' || level > 6 )? (
                                                        <>
                                                        &nbsp;&nbsp;&nbsp;<TextInput formClassName={classes.inlineBlock} source="q_init" label='QA Initial'/>&nbsp;
                                                        &nbsp;&nbsp;&nbsp;<DateInput formClassName={classes.inlineBlock} source="q_dt" label='QA Date' />&nbsp;
                                                        &nbsp;&nbsp;&nbsp;<BooleanInput formClassName={classes.inlineBlock} source="is_qa" label='QA Approved'/>
                                                        </>
                                                    ) : <>
                                                        &nbsp;&nbsp;&nbsp;<TextInput formClassName={classes.inlineBlock} source="q_init" label='QA Initial' disabled/>&nbsp;  
                                                        &nbsp;&nbsp;&nbsp;<DateInput formClassName={classes.inlineBlock} source="q_dt" label='QA Date' disabled />&nbsp;
                                                        &nbsp;&nbsp;&nbsp;<BooleanInput formClassName={classes.inlineBlock} source="is_qa" label='QA Approved' disabled/>
                                                        </>
                                                }
                                        </FormDataConsumer>
                                    </SimpleFormIterator>
                                </ArrayInput>
                                </td>
                            </tr>
                        </table>
                        
                        </td>
                    </tr>
                    <FormDataConsumer>
                    {({
                        formData, // The whole form data
                        scopedFormData, // The data for this item of the ArrayInput
                        getSource, // A function to get the valid source inside an ArrayInput
                        ...rest
                    }) =>
                        ( role==='QA' || role==='Admin' || level > 6 )? (
                    <tr>
                        <td  colSpan={8}>
                            <table  className={classes.tableStyle} >
                            <tr>
                                <td>Manager Monthly Review (initial)</td>
                                <td><TextInput source='manager_init' label='' /></td>
                                <td>Manager Monthly Review (Date)</td>
                                <td><DateInput source="manager_date"    label="" locales="en-us"  /></td>
                                <td>CMD Monthly Review (initial)</td>
                                <td><TextInput source='cmd_init' label='' /></td>
                                <td>CMD Monthly Review (Date)</td>
                                <td><DateInput source="cmd_date"    label="" locales="en-us"  /></td>
                            </tr>
                            <tr>
                                <td>QA Monthly Review (Initial)</td>
                                <td><TextInput source='qa_init' label='' /></td>
                                <td>QA Monthly Review (Date)</td>
                                <td><DateInput source="qa_date"    label="" locales="en-us"  /></td>
                                <td colSpan={4}>  </td>
                            </tr>
                            </table>
                        </td>
                    </tr>
                     ) : <></>
                    }
                    </FormDataConsumer>
                </tbody>
            </table>
                        
                    </>
             : <Redirect to='/calinstrument' />}
        </SimpleForm>
        
    </Create> 
</ErrorBoundary>  
);

export default  withStyles(formStyles) (InstCreate);
